<template>
  <div class="flex header-nav align-items">
    <div class="flex align-items" style="flex: 1">
      <a href="/">
				<img v-if="$functions.isFoTon()" src="../assets/foton/foton56black.png" alt="" class="logo" />
        		<img v-else src="../assets/logo_small2.png" alt="" class="logo" />
			</a>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        :text-color="textColor"
      >
        <el-menu-item index="1">
          <router-link to="/" :style="{ color: color }">首页</router-link>
          <span></span>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link to="survey">问卷调研</router-link>
          <span></span>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link to="template">问卷模板</router-link>
          <span></span>
        </el-menu-item>
        <!-- <el-menu-item index="4">
          <router-link to="Questionnsquare">问卷广场</router-link>
          <span></span>
        </el-menu-item> -->
       <!-- <el-menu-item index="5">
          <router-link to="about" :style="{ color: color }">
            关于我们</router-link
          >
          <span></span>
        </el-menu-item> -->
        <!-- <el-menu-item index="5">
          <a href="/download.html" :style="{ color: color }">App下载</a>
          <span></span>
        </el-menu-item> -->
      </el-menu>
    </div>
    <div class="flex flex-end" v-if="state == 1">
      <div class="login login1 flex justify-content" @click="login(1)">
        登录
      </div>
      <!-- <div
        class="login login2 flex align-items justify-content"
        v-if="activeIndex == 1"
        @click="login(3)"
      >
        注册
      </div>
      <div
        class="login login2 flex align-items justify-content"
        v-if="activeIndex != 1"
        style="color: #333; border: 1px solid #333"
        @click="login(3)"
      >
        注册
      </div> -->
    </div>
    <div class="flex flex-end" v-if="state == 2">
      <router-link to="my"
        ><div class="login login1 flex justify-content">
          我的问卷
        </div></router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["activeIndex", "textColor", "color"],
  data() {
    return {
      state: 1,
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    login(type) {
      this.$router.push({ path: "/login", query: { id: type } });
    },
  },
  created() {
    if (window.localStorage.getItem("token")) {
      this.state = 2;
    } else {
      this.state = 1;
    }
  },
};
</script>

<style lang="scss">
.header-nav {
  .menu {
    width: 100%;
  }
  .menu-item {
    font-size: 18px;
  }
  .el-menu--horizontal > .el-menu-item {
    font-size: 18px !important;
  }
  .el-menu {
    background: transparent;
  }
  .el-menu-item {
    margin-left: 25px !important;
    transition: border-color 0s, background-color 0s, color 0s !important;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: solid 1px transparent;
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background-color: transparent;
    color: #333;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0px solid #409eff;
    color: #333;
    position: relative;
  }
  .el-menu--horizontal > .el-menu-item.is-active span {
    display: block;
    position: absolute;
    width: 26px;
    height: 4px;
    border-radius: 2px;
    background: #409eff;
    left: 50%;
    top: 90%;
    transform: translate(-50%, -50%);
  }
  .el-menu-item a {
    padding: 20px 0;
  }
  .logo {
    width: 54px;
    margin-right: 10px;
    height: auto;
    cursor: pointer;
  }
  .header-nav {
    height: 68px;
  }
  .login {
    width: 82px;
    height: 32px;
    cursor: pointer;
    font-size: 16px;
    color: #fff;
  }
  .login1 {
    background: url("../assets/login_btn.png") no-repeat center;
    line-height: 32px;
  }
  .login2 {
    border: 1px solid #fff;
    color: #fff;
    border-radius: 5px;
    height: 28px;
    width: 78px;
    margin-left: 20px;
  }
}
</style>
